function e(o, r) {
  console.error(`[vueuc/${o}]: ${r}`);
}
export {
  e as warn
};
